import { z } from "zod";
export const ControlledAiPolicyResultV1Schema = z
    .object({
    schemaVersion: z.literal("controlled-ai-policy.v1.0"),
    requirementId: z.literal("AI-007"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
})
    .strict();
export function evaluateAiPolicyProbe(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiPolicyResultV1Schema.parse({
        schemaVersion: "controlled-ai-policy.v1.0",
        requirementId: "AI-007",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
export const AI_DENYLIST_TOOLS = ["activate_truth", "waive", "approve", "publish", "transfer"];
export function assertAiToolAllowed(toolName) {
    if (AI_DENYLIST_TOOLS.includes(toolName)) {
        throw new Error("ai_tool_denied");
    }
}
//# sourceMappingURL=policy.js.map